
<mat-nav-list>
    <div class="profile-card">
        <div class="header">
            <h2>{{name.name}}</h2>
            <h4>{{name.email}}</h4>
        </div>
        <img src="{{name.image.url}}" alt="Soufiane FADIL">
    </div>
    <mat-divider></mat-divider>
    <h2 matSubheader>Pages</h2>

    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard">
        <mat-icon>dashboard</mat-icon>
        Dashboard</a>
   
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/member">
        <mat-icon>people_alt</mat-icon>
        Members List
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/category">
        <mat-icon>branding_watermark</mat-icon>
       Catagory
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/SubCatagories">
        <mat-icon>branding_watermark</mat-icon>
       Sub Catagory
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/orders">
        <mat-icon>local_mall</mat-icon>
        Order Manager
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/offerManager">
        <mat-icon>local_offer</mat-icon>
        Offer Manager
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/deliveryList">
        <mat-icon>transfer_within_a_station
        </mat-icon>
        Delivery Partners
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/Baners">
        <mat-icon>assistant_photo
        </mat-icon>
        Banner
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/dishes">
        <mat-icon>fastfood
        </mat-icon>
        Dishes
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/voucherList">
        <mat-icon>label
        </mat-icon>
        Voucher
    </a>
    
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/restaurantList">
        <mat-icon>restaurant
        </mat-icon>
        Restaurant Manager
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/manageContent">
        <mat-icon>event_note
        </mat-icon>
        Manage Content
    </a>
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/contact">
        <mat-icon>contact_support
        </mat-icon>
        Contact
    </a>
  

    
    <!-- <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/user">
        <mat-icon>person</mat-icon>
        User Profile
    </a>
    
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/addNotification">
        <mat-icon>notifications</mat-icon>
        Add Notification
    </a>
    
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard/notification">
        <mat-icon>notifications</mat-icon>
        Notification
    </a>
     -->
   

   

</mat-nav-list>